import * as React from "react";
import useProductName from "brand-customization/useProductName";
import { useTranslation } from "react-i18next";
import { Col, Row } from "components/bootstrap";
import { DocumentTitle, PageHeader } from "components/common";
import DocsHelper from "util/DocsHelper";
import { LICENSE_SUBJECTS } from "license/constants";
import LicenseCheck from "license/LicenseCheck";
import ReportsList from "./ReportsList";
import ReportsSubNav from "../common/ReportsSubNav";
const ReportsPage = () => {
  const { t } = useTranslation("enterprise_report");
  const productName = useProductName();
  return /* @__PURE__ */ React.createElement(DocumentTitle, { title: t("reports_page.title") }, /* @__PURE__ */ React.createElement(
    PageHeader,
    {
      title: t("reports_page.title"),
      actions: /* @__PURE__ */ React.createElement(ReportsSubNav, null),
      documentationLink: {
        title: t("reports_page.documentation_link"),
        path: DocsHelper.PAGES.REPORTING
      }
    },
    /* @__PURE__ */ React.createElement("span", null, t("reports_page.description", { productName }))
  ), /* @__PURE__ */ React.createElement(LicenseCheck, { licenseSubject: LICENSE_SUBJECTS.report, bsStyle: "danger", displayWarningContainer: true, hideChildren: true }, /* @__PURE__ */ React.createElement(Row, { className: "content" }, /* @__PURE__ */ React.createElement(Col, { md: 12 }, /* @__PURE__ */ React.createElement(ReportsList, null)))));
};
export default ReportsPage;
